export default __webpack_public_path__ + "073b304ac83f20fedb6989c6105907c5.jpg";